import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { DocumentDetail } from "@/features/document";
import { maskSearchFragment } from "@/features/shared/route-masking";

export const Route = createFileRoute("/document/$slug")({
  validateSearch: z.object({
    /** The open section's slug; the document's first section when absent or unknown. */
    section: z.string().optional(),
    ...maskSearchFragment,
  }),
  component: DocumentDetail,
});
